import { faCodeBranch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames/bind";
import { RouteNames } from "enums";
import { GenericPerformanceList } from "features/Reporting/Content/shared/GenericPerformanceList";
import { type FC } from "react";
import { type ColumnOption } from "../../../../../interfaces/columnOptions";
import { TextTruncate } from "components";
import { Tooltip } from "components/common/tooltip";
import { thisMonthColumn } from "./shared";
import { type PerformanceFilter, completions, inProgress } from "features/Library/Common/utils/performanceUtils";

import styles from "./trendingTable.module.scss";
import { MoboLink } from "components/MoboLink/MoboLink";

const cx = cn.bind(styles);

export type TrendingFlow = {
  id: number;
  FlowId: number;
  FlowTitle: string;
  FlowStatus: "Published" | "Draft";
  Users: number;
  InProgress: number;
  Completes: number;
  Trending: number;
  TrendingLastMonth: number;
  TrendingChange: "Up" | "Down" | "No Change";
};

export interface TrendingFlowsProps {
  trendingFlows: TrendingFlow[];
  filter: PerformanceFilter;
}

const columnOptions: ColumnOption<TrendingFlow>[] = [
  {
    name: "THIS MONTH",
    width: 2,
    render: thisMonthColumn,
    isSortable: false,
  },
  {
    render: (entity) => {
      return (
        <div className={styles.title}>
          <FontAwesomeIcon icon={faCodeBranch} />
          <Tooltip
            target={
              <TextTruncate>
                <MoboLink to={`/${RouteNames.contentFlows}/${entity.FlowId}`}>{entity.FlowTitle}</MoboLink>
              </TextTruncate>
            }
            content={entity.FlowTitle}
          />
        </div>
      );
    },
    name: "FLOW",
    isSortable: false,
    width: 4,
  },
  {
    name: "TOTAL USERS",
    width: 3,
    isSortable: false,
    render: (entity) => {
      return <div>{entity.Users.toLocaleString()}</div>;
    },
  },
  {
    name: inProgress.toUpperCase(),
    width: 3,
    isSortable: false,
    render: (entity) => {
      return <div>{entity.InProgress.toLocaleString()}</div>;
    },
  },
  {
    name: completions.toUpperCase(),
    width: 3,
    isSortable: false,
    render: (entity) => {
      return <div>{entity.Completes.toLocaleString()}</div>;
    },
  },
  {
    name: "LAST MONTH",
    width: 2,
    isSortable: false,
    render: (entity) => {
      return <div className={styles.previouslyTrending}>{entity.TrendingLastMonth.toLocaleString()}</div>;
    },
  },
];

export const TrendingFlows: FC<TrendingFlowsProps> = (props) => {
  const { trendingFlows, filter } = props;

  return (
    <>
      <MoboLink className={cx(styles.root, styles.trendingFlows)} to={`../${RouteNames.contentFlows}`}>
        More Details
      </MoboLink>
      <GenericPerformanceList
        hideControls
        rows={trendingFlows}
        columns={columnOptions}
        title="Trending Flows"
        filter={filter}
      />
    </>
  );
};
